import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["ModalsToRender", "modalSpecificProps"];
import { useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const MultiStepModals = _ref => {
  let {
      ModalsToRender,
      modalSpecificProps
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [currentOpenModalIndex, setCurrentOpenModalIndex] = useState(0);
  // Save success handlers for each modal to be executed by the final modal step
  const [multiStepModalSuccessHandlers, setMultiStepModalSuccessHandlers] = useState([]);
  const [multiStepModalOverrideCrmObjects, setMultiStepModalOverrideCrmObjects] = useState();
  const openNextModal = ({
    /************
    These options are needed to support multi-step modals, currently.
    We need defer the action success handlers for the first modal(s) until the final modal step
    because calls to listingLibObserver will unmount rows, where the action modals are rendered
    by framework-listing-lib (source: https://hubspot.slack.com/archives/C021HGE3YNT/p1731948890421719).
     This is a workaround to ensure the success handlers are called after the final modal step, but
    leaves responsibility to the modal components themselves to know how to pass/call the success handlers
    and override the `crmObjects` as needed between the modal
    **************/
    crmObjects,
    currentModalOnActionSuccess
  }) => {
    if (currentModalOnActionSuccess) {
      setMultiStepModalSuccessHandlers([...multiStepModalSuccessHandlers, currentModalOnActionSuccess]);
    }
    if (crmObjects) {
      setMultiStepModalOverrideCrmObjects(crmObjects);
    }
    if (currentOpenModalIndex < ModalsToRender.length - 1) {
      setCurrentOpenModalIndex(currentOpenModalIndex + 1);
    }
  };
  const ModalComponent = ModalsToRender[currentOpenModalIndex];
  const modalSpecificPropsForCurrentModal = modalSpecificProps === null || modalSpecificProps === void 0 ? void 0 : modalSpecificProps[currentOpenModalIndex];
  return /*#__PURE__*/_jsx(ModalComponent, Object.assign({}, modalSpecificPropsForCurrentModal, rest, {
    openNextModal: openNextModal,
    crmObjects: multiStepModalOverrideCrmObjects || rest.crmObjects,
    isMultiStepModal: true,
    multiStepModalSuccessHandlers: multiStepModalSuccessHandlers
  }));
};
export default MultiStepModals;